module.exports = __webpack_public_path__ + "static/media/event-services-img36.de9c221c.jpg";